import { baseAxios, errorHandler } from "../index";

export async function getListPelunasan(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      "webPelunasan/getListPelunasan",
      {
        params: {
          page: data.page,
          limit: data.limit,
          cari: data.cari || "",
          statusPengajuan: data.statusPengajuan || "",
          _user: localStorage.getItem("ID") || "",
          _ts: Date.now(),
        },
        headers: {
          token: localStorage.getItem("token"),
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      },
    );

    if (response.status === 304) {
      return { ...response, data: { data: { docs: [], totalDocs: 0 } } };
    }

    dispatch({
      type: "SET_GET_LIST_PELUNASAN",
      data: response.data.data,
    });
    dispatch({
      type: "SET_DETAIL_PELUNASAN",
      data: response.data.data.docs,
    });

    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function approvePelunasan(data) {
  try {
    const response = await baseAxios.post(
      "webPelunasan/approvalPelunasan",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function exportPengajuanPelunasan(data) {
  try {
    const response = await baseAxios.post(
      "webPelunasan/exportPelunasanExcel",
      data,
      {
        headers: { token: localStorage.getItem("token") },
        responseType: "blob",
      },
    );

    return response.data;
  } catch (err) {
    return err.response;
  }
}
export async function showUrlDokumen(dispatch, data, history) {
  try {
    const response = await baseAxios.post("webPelunasan/showUrlDokumen", data, {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({
      type: "SHOW_URL_DOKUMEN",
      data: response.data.url,
    });
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function showUrlDokumenMasuk(dispatch, data, history) {
  try {
    const response = await baseAxios.post("webPelunasan/showUrlDokumen", data, {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({
      type: "SHOW_URL_DOKUMEN_MASUK",
      data: response.data.url,
    });
    return response;
  } catch (err) {
    return err.response;
  }
}
